import { render, staticRenderFns } from "./tRoles.vue?vue&type=template&id=6d0dc0f2&scoped=true"
import script from "./tRoles.vue?vue&type=script&lang=js"
export * from "./tRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0dc0f2",
  null
  
)

export default component.exports